import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["FAQAccordion"] */ "/vercel/path0/src/components/home/FAQAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HoverInfo"] */ "/vercel/path0/src/components/HoverInfo.tsx");
